import { create } from 'zustand';

interface IScheduledItems {
  scheduledItems: string[];
  setScheduledItems: (props: string[]) => void;
}

export const useScheduledItems = create<IScheduledItems>(set => ({
  scheduledItems: [],
  setScheduledItems: value => set(() => ({ scheduledItems: value }))
}));
